export const loadFields = (t) => {
  const translate = (key, fallback) => {
    if (typeof t !== 'function') return fallback

    const translated = t(key)

    return translated === key ? fallback : translated
  }

  return [
    {
      key: 'product.name',
      label: translate('delivery.loadsTable.fields.productName', 'Nama Produk'),
      isSortable: true,
    },
    {
      key: 'product.product_type.name',
      label: translate('delivery.loadsTable.fields.productType', 'Jenis Produk'),
      isSortable: true,
    },
    {
      key: 'quantity',
      label: translate('delivery.loadsTable.fields.quantity', 'Kuantitas'),
      isSortable: true,
    },
    {
      key: 'uom',
      label: translate('delivery.loadsTable.fields.unit', 'Satuan Kuantitas'),
    },
    {
      key: 'total_weight',
      label: translate('delivery.loadsTable.fields.weight', 'Berat'),
      isSortable: true,
      afterText: 'Kg',
    },
    {
      key: 'total_volume',
      label: translate('delivery.fields.volume', 'Volume'),
      isSortable: true,
      afterText: 'Cbm',
    },
    {
      key: 'note',
      label: translate('global.field.note', 'Catatan'),
    },
  ]
}
